module.exports = __webpack_public_path__ + "static/icon_color_restaurant-670ab0e35a4e8e69d31ec708baef5a45.png";